<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <b-card class="shadow" no-body>
            <b-card-body>
              <div v-if="error.length" class="alert alert-danger">
                {{ error.errors || error }}
              </div>
              <!-- <h5>Archivo de Facturas Emitidas</h5> -->
              <b-row class="d-flex">
                <b-form-group
                  label="Sucursal"
                  class="px-1 mb-0"
                  label-size="sm"
                >
                  <b-form-select v-model="filter.sucursal_id" size="sm">
                    <b-form-select-option value=""
                      >Todas mis sucursales</b-form-select-option
                    >
                    <b-form-select-option
                      v-for="(sucursal, ks) in sucursales"
                      :key="ks"
                      :value="sucursal.id"
                    >
                      {{ sucursal.nombre }}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <!-- <b-form-group
                  label="Del"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="date"
                    class="form-control-solid"
                    v-model="filter.init"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Al"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="date"
                    class="form-control-solid"
                    v-model="filter.end"
                  ></b-form-input>
                </b-form-group> -->
                <b-form-group
                  label="Del"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="date"
                    class="form-control-solid"
                    v-model="filter.init"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Al"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="date"
                    class="form-control-solid"
                    v-model="filter.end"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Serie"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-select v-model="filter.serie_public" size="sm">
                    <b-form-select-option value="T001"
                      >T001</b-form-select-option
                    >
                    <b-form-select-option value="F001"
                      >F001</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Folio"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="text"
                    class="form-control-solid"
                    v-model="filter.folio"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Total"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="number"
                    class="form-control-solid"
                    v-model="filter.total"
                  ></b-form-input>
                </b-form-group>

                <div class="mt-auto flex-fill">
                  <b-button @click="getFind()" variant="primary" size="sm" block
                    >Buscar</b-button
                  >
                </div>
              </b-row>
              <div class="row">
                <div class="col">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th></th>
                        <th class="text-center">Serie</th>
                        <th class="text-center">Folio</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">Total</th>
                        <th class="text-center">Factura</th>
                        <th class="w-auto"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="working">
                        <td colspan="7" class="text-center bg-light">
                          <span
                            class="d-flex align-items-center justify-content-center"
                          >
                            <i class="fas fa-spin fa-spinner fa-2x mr-2"></i>
                            Buscando
                          </span>
                        </td>
                      </tr>
                      <tr v-for="(element, key) in facturas" :key="key">
                        <td class="text-center">
                          <i class="fas fa-file-code fa-2x"></i>
                        </td>
                        <td class="text-right">{{ element.numalbaran }}</td>
                        <td class="text-center">{{ element.numserie }}</td>
                        <td class="text-center">
                          {{
                            moment(element.fecha).utc().format("DD-MM-YYYY")
                          }}
                          {{ moment(element.hora).utc().format("H:mm:ss") }}
                        </td>
                        <td class="text-right">{{ element.total }}</td>
                        <td class="text-center">{{ element.uuid }}</td>
                        <td class="text-center">
                          <div
                            v-if="
                              element['uuid'] != undefined ||
                              element.fglobal > 0
                            "
                          >
                            <!-- <p class="mr-3">Ticket Facturado: {{ element.numalbaran }}</p> -->
                            <!-- <p v-if="element.fglobal > 0" class="mr-3 text-danger">
                              <strong
                                >El ticket se facturo como global por cierre de
                                mes.</strong
                              >
                            </p> -->
                            <span
                              v-if="element.fglobal > 0"
                              class="badge badge-danger"
                              >F. Global</span
                            >
                            <b-button
                              v-if="element.fglobal == 0"
                              :href="`${$backend}/api/facturacion/descargar/${element.uuid}`"
                              variant="info"
                              size="sm"
                              class="text-primary"
                              target="_blank"
                              download
                            >
                              <i class="fas fa-download mr-1"></i>Descargar ZIP
                            </b-button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr v-for="(element, key) in tickets" :key="key">
                        <td class="text-center">
                          <i class="far fa-file-alt fa-2x"></i>
                        </td>
                        <td class="text-right">{{ element.NUMALBARAN }}</td>
                        <td class="text-center">{{ element.NUMSERIE }}</td>
                        <td class="text-center">
                          {{
                            moment(element.FECHA).utc().format("DD-MM-YYYY")
                          }}
                          {{ moment(element.HORA).format("H:mm:ss") }}
                        </td>
                        <td class="text-right">{{ element.TOTALNETO }}</td>
                        <td class="text-center">{{ element.uuid }}</td>
                        <td class="text-center">
                          <div
                            v-if="
                              element['uuid'] != undefined ||
                              element.fglobal > 0
                            "
                          >
                            <!-- <p class="mr-3">Ticket Facturado: {{ element.numalbaran }}</p> -->
                            <!-- <p v-if="element.fglobal > 0" class="mr-3 text-danger">
                              <strong
                                >El ticket se facturo como global por cierre de
                                mes.</strong
                              >
                            </p> -->
                            <span
                              v-if="element.fglobal > 0"
                              class="badge badge-danger"
                              >F. Global</span
                            >
                            <b-button
                              v-if="element.fglobal == 0"
                              :href="`${$backend}/api/facturacion/descargar/${element.uuid}`"
                              variant="info"
                              size="sm"
                              class="text-primary"
                              target="_blank"
                              download
                            >
                              <i class="fas fa-download mr-1"></i>Descargar ZIP
                            </b-button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <template v-for="(element, ke) in elements">
                <div
                  v-if="element"
                  class="row mt-3 w-100 justify-content-center"
                  :key="ke"
                >
                  <!-- TICKET FACTURADO -->
                  <div
                    v-if="element['uuid'] != undefined || element.fglobal > 0"
                  >
                    <p class="mr-3">
                      Ticket Facturado: {{ element.numalbaran }}
                    </p>
                    <p v-if="element.fglobal > 0" class="mr-3 text-danger">
                      <strong
                        >El ticket se facturo como global por cierre de
                        mes.</strong
                      >
                    </p>
                    <b-button
                      v-if="element.fglobal == 0"
                      :href="`${$backend}/api/facturacion/descargar/${element.uuid}`"
                      variant="info"
                      size="sm"
                      class="text-primary"
                      target="_blank"
                      download
                    >
                      <i class="fas fa-download mr-1"></i>Descargar ZIP
                    </b-button>
                  </div>
                  <!-- TICKET NO FACTURADO -->
                  <div v-if="element['TOTALNETO'] != undefined">
                    <p class="mr-3 text-center text-success">
                      <strong>Ticket Localizado</strong> (El ticket no tiene
                      factura.)
                    </p>
                    <p class="d-block mb-0 text-center">
                      Folio: <strong>{{ element.NUMALBARAN }}</strong>
                    </p>
                    <p class="d-block mb-0 text-center">
                      Fecha: <strong>{{ element.FECHA }}</strong>
                    </p>
                    <!-- <p class="d-block mb-0">{{ element.HORA }}</p> -->
                  </div>
                </div>
              </template>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from "moment";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";

export default {
  components: {
    ButtonDelete,
  },
  data() {
    return {
      moment: moment,
      working: false,
      error: [],
      sucursales: [],
      filter: {
        sucursal_id: "",
        init: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        total: "",
        folio: "",
        serie_public: "T001",
      },
      fileds: [
        {
          key: "serie",
          label: "SERIE",
          sortable: true,
        },
        {
          key: "fechaTimbrado",
          label: "FECHA TIMBRADO",
          sortable: true,
        },
        {
          key: "folio",
          label: "folio",
          sortable: true,
        },
        {
          key: "total",
          label: "TOTAL",
          class: "text-right",
          sortable: true,
        },
        {
          key: "emisor",
          label: "Emisor",
          sortable: true,
        },
        {
          key: "receptor",
          label: "Receptor",
          sortable: true,
        },
        {
          key: "acciones",
          label: "ACCIONES",
          class: "text-center",
          sortable: false,
        },
      ],
      elements: [],
      element: null,
      facturas: [],
      tickets: [],
      cfdi: {},
    };
  },
  beforeMount() {
    this.getSucursales();
    // this.getFind();
  },
  methods: {
    filterReset() {
      this.filter = {
        sucursal_id: "",
        init: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        total: "",
        folio: "",
        serie_public: "",
      };
    },
    getSucursales() {
      this.$api
        .get("/facturacion/sucursales")
        .then((response) => {
          this.sucursales = response.data;
        })
        .catch((e) => console.error(e));
    },
    getFind() {
      this.working = true;
      this.facturas = [];
      this.tickets = [];
      this.error = [];

      this.$api
        .get("/archivo/ticket", {
          params: this.filter,
        })
        .then((res) => {
          const { facturas, tickets } = res.data;
          this.facturas = facturas;
          this.tickets = tickets;
          // this.filterReset();
        })
        .catch((e) => {
          this.error = e.response.data.errors || e.response.data;
        })
        .then(() => {
          this.working = false;
        });
    },
    modalActions(item, index, target) {
      this.cfdi = item;
      this.$refs["modal-cfdi-acciones"].show();
    },
    cacelCfdi(folio) {
      this.working = true;

      this.$api
        .delete(`facturacion/cfdi/${folio}/cancelar`)
        .then((response) => {
          this.$notiflix.Notify.success("Cancelación exitosa.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
  },
  filters: {
    formatNumberDecimal: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 2,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
    formatNumberInteger: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 0,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
